// extracted by mini-css-extract-plugin
export var sliderRange = "_od-2";
export var sliderRoot = "_od-0";
export var sliderThumb = "_od-3";
export var sliderTrack = "_od-1";